export const matchData = [
    {
      id: 1,
      title: 'Morning Practice vs. Team Blue',
      time: 'Today, 08:30 AM - 09:00 AM',
      duration: '30:00',
      quality: '4K Ultra',
      qualityColor: '#10B981',
      price: '$2.99',
      hot: false,
      gradient: 'from-gray-300 to-gray-400',
      gradientDir: 'bg-gradient-to-br',
    },
    {
      id: 2,
      title: 'Morning Practice Extended',
      time: 'Today, 09:00 AM - 09:45 AM',
      duration: '45:00',
      quality: '4K Ultra',
      qualityColor: '#10B981',
      price: '$3.99',
      hot: true,
      gradient: 'from-gray-300 to-gray-400',
      gradientDir: 'bg-gradient-to-bl',
    },
    {
      id: 3,
      title: 'Singles Drill Session',
      time: 'Today, 09:45 AM - 10:15 AM',
      duration: '30:00',
      quality: '1080p HD',
      qualityColor: '#64748B',
      price: '$1.99',
      hot: false,
      gradient: 'from-gray-300 to-gray-400',
      gradientDir: 'bg-gradient-to-tr',
    },
    {
      id: 4,
      title: 'Cool Down & Serving',
      time: 'Today, 10:15 AM - 10:30 AM',
      duration: '15:00',
      quality: '4K Ultra',
      qualityColor: '#10B981',
      price: '$1.49',
      hot: false,
      gradient: 'from-gray-400 to-gray-300',
      gradientDir: 'bg-gradient-to-br',
    },
  ];
  
  export const courtLabels = {
    main: 'Center Court',
    north1: 'North Facility - Court 1',
    north2: 'North Facility - Court 2',
    south1: 'South Gym - Court A',
    south2: 'South Gym - Court B',
    outdoor: 'Outdoor Courts - Championship',
  };
  
  export const timeOptions = [
    { value: '05:00', label: '5:00 AM' },
    { value: '05:30', label: '5:30 AM' },
    { value: '06:00', label: '6:00 AM' },
    { value: '06:30', label: '6:30 AM' },
    { value: '07:00', label: '7:00 AM' },
    { value: '07:30', label: '7:30 AM' },
    { value: '08:00', label: '8:00 AM' },
    { value: '08:30', label: '8:30 AM' },
    { value: '09:00', label: '9:00 AM' },
    { value: '09:30', label: '9:30 AM' },
    { value: '10:00', label: '10:00 AM' },
    { value: '10:30', label: '10:30 AM' },
    { value: '11:00', label: '11:00 AM' },
    { value: '11:30', label: '11:30 AM' },
    { value: '12:00', label: '12:00 PM' },
    { value: '12:30', label: '12:30 PM' },
    { value: '13:00', label: '1:00 PM' },
    { value: '13:30', label: '1:30 PM' },
    { value: '14:00', label: '2:00 PM' },
    { value: '14:30', label: '2:30 PM' },
    { value: '15:00', label: '3:00 PM' },
    { value: '15:30', label: '3:30 PM' },
    { value: '16:00', label: '4:00 PM' },
    { value: '16:30', label: '4:30 PM' },
    { value: '17:00', label: '5:00 PM' },
    { value: '17:30', label: '5:30 PM' },
    { value: '18:00', label: '6:00 PM' },
    { value: '18:30', label: '6:30 PM' },
    { value: '19:00', label: '7:00 PM' },
    { value: '19:30', label: '7:30 PM' },
    { value: '20:00', label: '8:00 PM' },
    { value: '20:30', label: '8:30 PM' },
    { value: '21:00', label: '9:00 PM' },
    { value: '21:30', label: '9:30 PM' },
    { value: '22:00', label: '10:00 PM' },
    { value: '22:30', label: '10:30 PM' },
    { value: '23:00', label: '11:00 PM' },
    { value: '23:30', label: '11:30 PM' },
    { value: '00:00', label: '12:00 AM' },
    { value: '00:30', label: '12:30 AM' },
  ];
  
  export const dateOptions = ['Two Days Ago', 'Yesterday', 'Today'];